package com.vizio.redwolf.auth.model


/**
 * Create Account Request with birthdate and gender
 * Mobile will pass in null for birthdate and gender until adding in this functionality
 * After adding in the functionality, mobile MUST pass in a value for birthdate and gender at all times
 * as it is a required field
 */
data class CreateAccount2RequestInfo(
    val email: String,
    val password: String,
    val firstName: String?,
    val lastName: String?,
    val postalCode: String?,
    val phoneNumber: String?,
    val reCaptchaToken: String? = null,
    val birthDate: String? = null,
    val gender: String? = null
)